export const SELECT_SUPERUSER= 'SELECT_SUPERUSER'
export const SELECT_SUPERUSER_SUCCESS= 'SELECT_SUPERUSER_SUCCESS'
export const SELECT_SUPERUSER_ERROR='SELECT_SUPERUSER_ERROR'

export const SelectSuperUser= (data) => ({
    type: SELECT_SUPERUSER,
    payload: data
})